import { z } from 'zod';

import { BasePType } from './base';

export const ImageBanner = BasePType.extend({
  type: z.enum(['imageBanner']),
  backgroundImage: z.object({
    src: z.string(),
    alt: z.string(),
    target_id: z.string().optional(),
    title: z.string().optional(),
    width: z.string().optional(),
    height: z.string().optional(),
  }),
  backgroundPosition: z.string(),
  borderless: z.boolean(),
  containerType: z.string(),
  imageBackgroundClass: z.string(),
  title: z.string(),
  backgroundSize: z.string(),
  verticalAlign: z.string().nullable(),
});

export type ImageBanner = z.infer<typeof ImageBanner>;
